import classnames from 'classnames'
import React from 'react'
import { activatable } from './activatable'
import { useQuoteDocumentHeaderStyles } from './quoteDocumentHeaderStyles'

export interface HeaderLineLinkProps {
  /**
   * Omitted for a repeat of the line above it (a second email or phone): the icon's space is kept
   * blank so the value still lines up, but the icon is not drawn twice (ENG-2035).
   */
  icon?: React.ComponentType<{ className?: string }>
  onClick: () => void
  children: React.ReactNode
}

/**
 * One icon-prefixed detail line that deep-links on activation (tel:/mailto:/maps) — the repeated
 * building block of the contact / job-address / sales-rep columns. Clicks are kept from bubbling to the
 * enclosing column, so following the link never also opens that column's editor.
 *
 * A long value wraps within its column, with the icon pinned to the first line (see `wrapValue`).
 */
export default function HeaderLineLink({ icon: Icon, onClick, children }: HeaderLineLinkProps) {
  const classes = useQuoteDocumentHeaderStyles()
  return (
    <span
      className={classnames(classes.lineItem, classes.lineLink, {
        [classes.lineItemRepeat]: !Icon
      })}
      {...activatable(true, onClick, { stopPropagation: true })}
    >
      {Icon ? (
        <span className={classes.lineIconSlot}>
          <Icon className={classes.lineIcon} />
        </span>
      ) : (
        <span className={classes.lineIconSpacer} />
      )}
      <span className={classes.wrapValue}>{children}</span>
    </span>
  )
}
